import DynamicBreadcrumb from "@components/general/DynamicBreadcrumb/DynamicBreadcrumb";
import TitleDashboard from "@components/general/Titles/TitleDashboard";
import Loader from "@helpers/loader/loader";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Animated } from "react-animated-css";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import HistorialPagos from "./components/HistorialPagos";
import LiquidacionAdeudo from "./components/liquidacion/LiquidacionAdeudo";
import RenovacionLicencia from "./components/renovacion/RenovacionLicencia";
import UserContext from "@context/User/UserContext";
import { retrievePaymentIntent } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import { NotificationManager } from "react-notifications";
import EdoCuenta from "./components/edoCuenta/EdoCuenta";
import { getOrdenKueskiByFolio } from "@helpers/httpRequests/httpRequestKueski/httpRequesKueski";
import { getLeccionesVistas } from "@helpers/httpRequests/httpRequestLeccionesVistas/httpRequestsLeccionesVistas";
import { getLeccionByCodigoIngles } from "@helpers/httpRequests/httpRequestCursoIngles/httpRequestCursoIngles";
import { getLeccionByCodigo, getUltimaLeccionTomada } from "@helpers/httpRequests/httpRequestsLecciones/httpRequestsLecciones";
import { getTiempoPlataforma } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import moment from "moment";
import getDateFromUnix from "@helpers/dates/getDateFromUnix/getDateFromUnix";
import SuscripcionLicencia from "./components/suscripcion/SuscripcionLicencia";
import { useTranslation } from "react-i18next";
import getUnixTimestamp from "@helpers/dates/getUnixTimestamp/getUnixTimestamp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faContactBook, faPhone } from "@fortawesome/free-solid-svg-icons";

const MisPagos = () => {

	const {t} = useTranslation();

	const { contextValue, setContextValue } = useContext(UserContext);

	const { renovacion, usuarioLogeado } = contextValue;

	const { servicioActivo, folioContrato, idPerfil, idPersona, fechaUltimoAcceso, nombreLicencia, fechaExpiracion } = usuarioLogeado;

	const [showLoader, setShowLoader] = useState(true);

	const [key, setKey] = useState("edoCuenta");

	const [leccionesVistas, setLeccionesVistas] = useState([]);

	const [leccionesListadas, setLeccionesListadas] = useState([]);

	const [ultimaLeccionTomada, setUltimaLeccionTomada] = useState(null);

	const [ultimaLeccion, setUltimaLeccion] = useState(null);


	const [yearsPlataforma, setYearsPlataforma] = useState(0);

	const [mesesPlataforma, setMesesPlataforma] = useState(0);

	const [diasPlataforma, setDiasPlataforma] = useState(0);

	const [horasPlataforma, setHorasPlataforma] = useState(0);

	const [minutosPlataforma, setMinutosPlataforma] = useState(0);

	const [showTiempoPlataforma, setShowTiempoPlataforma] = useState(false);

	const [fechaHoy, setFechaHoy] = useState(getUnixTimestamp());


	const consultarPaymentIntent = async () => {
		try {
			const { paymentIntent } = await retrievePaymentIntent(renovacion.stripeSession.payment_intent);

			if (paymentIntent.status === "succeeded") {

				setKey('renovacion');

				setContextValue({
					...contextValue,
					renovacion: {
						...contextValue.renovacion,
						pagoIniciado: false,
						pagoFinalizado: true
					}
				});
				NotificationManager.success('¡Pago de renovación aplicado!');
			}
		} catch (error) {
			console.log("errpr al consultar el payment intent: ", error);
		}
	};

	const consultarOrdenKueski = async () => {
		try {
			//consulta a bd para recuperar la orden ded kueski

			const { data } = await getOrdenKueskiByFolio(folioContrato);

			console.log(data);

			if (data.estatus === "orden_aceptada") {
				setKey('renovacion');

				setContextValue({
					...contextValue,
					renovacion: {
						...contextValue.renovacion,
						pagoIniciado: false,
						pagoFinalizado: true
					}
				});
				NotificationManager.success('¡Pago de renovación aplicado!');
			} else {
				console.log("No se aplica el pago de renovacion")
			}

			//validar si el estatus de la orden es 'orden_aceptada' y actualizar el contextValue.
		} catch (error) {
			console.log("Error al recuperar la orden Kueski.", error);
		}
	}

	//TODO: OBTENER EL PARAM reactivated para poder actualizar el context del usuario y detecte la renovacion.

	useEffect(() => {

		const obtenerHistorial = async () => {
			try {
				try {
					const { data } = await getLeccionesVistas(idPerfil);
					if (Array.isArray(data)) {
						setLeccionesVistas(data);
					} else {
						setLeccionesVistas([data]);
					}
					setLeccionesListadas(true);
				} catch (error) {
					console.log(error);
				}
			} catch (error) {
				console.log(error);
			}
		};

		obtenerHistorial();

		const ultimaLeccion = async () => {
			try {
				const {
					data: { codigoLeccion },
				} = await getUltimaLeccionTomada(idPerfil);
				console.log(codigoLeccion)
				setUltimaLeccion(codigoLeccion)
				if (codigoLeccion.startsWith("ING")) {
					const { data: datos } = await getLeccionByCodigoIngles(codigoLeccion);

					setUltimaLeccionTomada(datos.nombre);
				} else {
					const { data: datos } = await getLeccionByCodigo(codigoLeccion);
					// console.log(datos);
					setUltimaLeccionTomada(datos.nombre);
				}
			} catch (error) {
				console.log(error);
			}
		};

		ultimaLeccion();

		const tiempoPlataforma = async () => {
			try {
				const { data } = await getTiempoPlataforma(idPersona);
				console.log(data);
				const { tiempoEnPlataforma } = data;

				const duracion = moment.duration(tiempoEnPlataforma, "minutes");

				const { days, hours, minutes, months, years } = duracion._data;

				setDiasPlataforma(days);
				setHorasPlataforma(hours);
				setMinutosPlataforma(minutes);
				setMesesPlataforma(months);
				setYearsPlataforma(years);

				setShowTiempoPlataforma(tiempoEnPlataforma === null ? false: true);
			} catch (error) {
				console.log(error);
			}
		};

		tiempoPlataforma();

		//TODO: hacer una distincion en las validaciones para compras mediante kueski.
		if (renovacion) {
			if (renovacion.pagoIniciado && renovacion.renovacionKueski === false) {
				console.log('consultando payment intent');

				consultarPaymentIntent();
			}
			if (renovacion.pagoIniciado && renovacion.renovacionKueski === true) {

				consultarOrdenKueski();
			}
		}

		if (!servicioActivo) {
			setKey('edoCuenta');
		}

		setTimeout(() => setShowLoader(false), 1500);
	}, []);

	return (
		<>
			{showLoader ? (
				<Loader height={"80vh"} setShowLoader={setShowLoader} />
			) : (
				<Animated animationIn="fadeIn" animationInDuration={2000} animationOut="fadeOut" isVisible={true}>
					<Container fluid className="p-4 mb-3">
						<DynamicBreadcrumb arrayBreadcrumbs={[{ title: "Mis Pagos", onClick: () => { } }]} />

						{!servicioActivo ? (
							<Row className="mt-4">
								<Col className="col-12 mb-4">
									<div className="p-3 shadow info-cuenta-avances">
										<h3>{t('userProgress.title')}</h3>
										<h4 className="text-warning">{(!servicioActivo && (fechaHoy < fechaExpiracion)) ? t('userProgress.paymentsUpToDate') : t('userProgress.renewMessage')}</h4>
										<p>
											<b>{t('userProgress.lastLogin')} </b>
											{fechaUltimoAcceso !== null ? getDateFromUnix(fechaUltimoAcceso) : "Hubo un error al recuperar la fecha de ultimo acceso"}
										</p>
										<p>
											<b>{t('userProgress.lastLesson')} </b>{ultimaLeccionTomada === null ? 'Sin lecciones vistas' : ultimaLeccionTomada}
										</p>
										{showTiempoPlataforma ? (
											<p>
												{t('userProgress.timeOnPlatform')}: {yearsPlataforma > 0 && `${yearsPlataforma} ${yearsPlataforma === 1 ? t('year') : t('years')}`}{" "}
												{mesesPlataforma > 0 && `${mesesPlataforma} ${mesesPlataforma === 1 ? t('month') : t('months')}`} {diasPlataforma > 0 && `${diasPlataforma} ${diasPlataforma === 1 ? t('day') : t('days')}`}{" "}
												{horasPlataforma > 0 && `${horasPlataforma} ${horasPlataforma === 1 ? t('hour') : t('hours')}`}{" "}
												{minutosPlataforma > 0 && `${minutosPlataforma} ${minutosPlataforma === 1 ? t('minute') : t('minutes')}`}
											</p>
										) : (
											<p>Tiempo en plataforma: Sin tiempo en plataforma</p>
										)}
									</div>
								</Col>
							</Row>
						) : null}

						{(!servicioActivo && (fechaHoy < fechaExpiracion)) ? (
							<Row className="mb-3 mt-5 mb-5">
								<Col className="text-center">
									<FontAwesomeIcon icon={faContactBook} size="4x" color="gray"/>
									<p className="mt-3" style={{color: "gray", fontWeight: "bolder"}}>
										Para seguir disfrutando de tus cursos y llevar tus habilidades al siguiente nivel, ponte en contácto al
									</p>
									<p className="mt-3" style={{color: "gray", fontWeight: "bolder"}}>
										(477) 390 8301 ext 104 
									</p>

									<p className="mt-3" style={{color: "gray", fontWeight: "bolder"}}>
										ó
									</p>

									<p className="mt-3" style={{color: "gray", fontWeight: "bolder"}}>
										cobranzagc@globalclickmexico.com 
									</p>
								</Col>
							</Row>
						): null}

						<Row className="mb-3 mt-4">
							<Col>
								<TitleDashboard title={servicioActivo ? nombreLicencia.includes('Suscripcion')? 'Estado de cuenta y suscripción' : 'Estado de cuenta y renovaciones' : 'Mis pagos' } />

								<Tabs className="mt-4" activeKey={key} onSelect={(k) => setKey(k)}>
									{/* <Tab eventKey="historialPagos" title="Historial de Pagos">
										<HistorialPagos />
									</Tab>

									<Tab eventKey="liquidacion" title="Liquidar adeudo">
										<LiquidacionAdeudo />
									</Tab> */}


									{(!nombreLicencia.includes("Suscripcion") && (fechaHoy > fechaExpiracion) ) && (
										<Tab eventKey="renovacion" title={t('renewLicense')}>
											<RenovacionLicencia />
										</Tab>
									)}

									{/* {(nombreLicencia.includes("Suscripcion") && (fechaHoy > fechaExpiracion)) && (
										<Tab eventKey="suscripcion" title="Tu suscripción Click+">
											<SuscripcionLicencia />
										</Tab>
									)} */}

									
									<Tab eventKey="edoCuenta" title={t('accountStatement')}>
										<EdoCuenta />
									</Tab>
								</Tabs>
							</Col>
						</Row>
					</Container>
				</Animated>
			)}
		</>
	);
};

export default MisPagos;
